import * as moment from 'moment';

import { Injectable, Inject } from 'ng-metadata/core';

import { ApiService } from 'services/api.service';
import { parseDomain } from '../helpers/parseDomain';

export interface UserInterface {
  loggedIn: boolean;
  data: {
    avatar: string;
    user_id: string;
    email: string;
    password: string;
    first_name: string;
    last_name: string;
  };
}

@Injectable('AuthService')
export class AuthService extends ApiService {
  public FS = (<any>window).FS;
  public ga = (<any>window).ga;

  public user: UserInterface;

  async getUser() {
    if (this.user) {
      return this.user;
    }

    try {
      const response = await this.getRequest('/check');
      this.user = this.buildUser(response.data);
      return this.user;
    } catch (e) {
      throw e;
    }
  }

  async loginUser(credentials): Promise<any> {
    try {
      const response: any = await this.postRequest('/auth/login', credentials);
      const user: any = this.buildUser(response.data);

      if (user.data && user.data.decoration) {
        const decoration = user.data.decoration;
        const session = await this.saveDecoration(decoration);
      }

      this.user = user;
      return this.user;
    } catch (e) {
      throw e;
    }
  }

  async logoutUser(): Promise<UserInterface> {
    try {
      const response = await this.$http
        .post(`${this.url}/auth/logout`, {}, {
          withCredentials: true,
        });

      if (this.FS) {
        this.FS.identify(false);
      }

      return this.buildUser(response);
    } catch (e) {
      throw e;
    }
  }

  async saveDecoration(decoration: string) {
    try {
      const response = await this.$http.post('/save/auth/session', { decoration });
      return response.data;
    } catch (e) {
      throw e;
    }
  }

  async confirmPassword(password: string, passwordConfirm: string) {
    const data = {
      password,
      password_confirmation: passwordConfirm,
    };

    return this.postRequest('/user/create/password', data);
  }

  async userExists(email: string) {
    const data = {
      email,
    };

    try {
      const response = await this.postRequest('/user/exists', data);
      return response;
    } catch (e) {
      return this.$q.reject(e);
    }
  }

  async hotlead(data) {
    const domain = parseDomain(window.location.href);
    const portal = domain.domain ? domain.domain : 'travelvisa';
    const etoms = this.etomsService.enabled() ? 'etoms/' : '';
    return this.postRequest(`/${etoms}hotlead/${portal}`, data);
  }

  setFullStoryVars(user) {
    if (!this.FS) {
      return false;
    }

    this.FS.identify(user.uuid, {
      email: user.email,
      displayName: `${user.first_name} ${user.last_name}`,
    });
  }

  async sendProof(account, geoip) {
    const url = process.env.MIX_PROOF;

    if (!url) {
      return;
    }

    const data = {
      type: 'custom',
      ip: geoip.ip,
      city: geoip.city,
      state: geoip.state,
      country: geoip.country,
      email: account.email,
      first_name: account.firstName,
      timestamp: moment().format('x'),
    };

    return this.$http.post(url, data);
  }

  buildUser(data) {
    if (data && data.uuid) {
      const user = {
        data,
        loggedIn: true,
      };

      this.setFullStoryVars(user.data);

      if (this.ga) {
        this.ga('set', 'userId', user.data.uuid);
      }

      return user;
    }

    return {
      data: null,
      loggedIn: false,
    };
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/auth.service.ts